import Joi from 'joi';

import { phoneSchema } from '../../../../shared/validators/schemas/phone.schema';

/**
 * Schema for contact validation belonging to a account with type set to company.
 * @returns {Joi.ObjectSchema} - A Joi object schema object.
 */
export const updateCompanyAccountContactSchema = () =>
  Joi.object({
    id: Joi.number().messages({
      'number.base': 'validations|contact-id|must-be-number',
    }),

    type: Joi.string(),

    source: Joi.string(),

    color: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-color|must-be-string',
    }),

    companyName: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|contact-company-name|cannot-be-null',
      }),
      otherwise: Joi.string().required().messages({
        'any.required': 'validations|contact-company-name|required',
        'string.base': 'validations|contact-company-name|must-be-string',
        'string.empty': 'validations|contact-company-name|must-not-be-empty',
      }),
    }),

    email: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-email|must-be-string',
    }),

    address1: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-address1|must-be-string',
    }),

    address2: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-address2|must-be-string',
    }),

    phoneLandline: phoneSchema().messages({
      'string.pattern.base': 'validations|contact-phone-landline|invalid',
      'string.base': 'validations|contact-phone-landline|must-be-string',
    }),

    phoneMobile: phoneSchema().messages({
      'string.pattern.base': 'validations|contact-phone-mobile|invalid',
      'string.base': 'validations|contact-phone-mobile|must-be-string',
    }),

    phoneFax: phoneSchema().messages({
      'string.pattern.base': 'validations|contact-phone-fax|invalid',
      'string.base': 'validations|contact-phone-fax|must-be-string',
    }),

    preferredContactFrom: Joi.date().allow(null).messages({
      'date.base':
        'validations|contact-preferred-contact-from|must-be-a-valid-date',
    }),

    preferredContactTo: Joi.date().allow(null).messages({
      'date.base':
        'validations|contact-preferred-contact-to|must-be-a-valid-date',
    }),

    city: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-city|must-be-string',
    }),

    postCode: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-post-code|must-be-string',
    }),

    poBox: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-po-box|must-be-string',
    }),

    county: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-county|must-be-string',
    }),

    state: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-state|must-be-string',
    }),

    countryId: Joi.number().allow(null).messages({
      'number.base': 'validations|contact-country-id|must-be-number',
    }),

    website: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-website|must-be-string',
    }),

    facebook: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-facebook|must-be-string',
    }),

    instagram: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-instagram|must-be-string',
    }),

    twitter_x: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-twitter_x|must-be-string',
    }),

    slack: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-slack|must-be-string',
    }),

    whatsApp: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-whatsapp|must-be-string',
    }),

    youtube: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-youtube|must-be-string',
    }),

    linkedIn: Joi.string().allow(null).messages({
      'string.base': 'validations|contact-linkedin|must-be-string',
    }),
  });
